import type { PortalProfile } from "@repo/edge/types";
export const patientDomainIdFromProfile = (profile: PortalProfile | undefined) => profile?.selectedPatientId;
export const selectedPatientFromProfile = (profile: PortalProfile | undefined) =>
  profile?.patients.find((patient) => patient.patientId === profile.selectedPatientId);
